import API from "../../api";

const RiskyOrder = {
  getOrders: (startDate, endDate) => {
    return API.get(`/order/risky?start=${startDate}&end=${endDate}`)
  }
}

export default RiskyOrder